<template>
  <div
    class="card px-2 py-2 mt-3 wrapper-ccsi"
    v-if="ccsiData.vendas.length > 0 || ccsiData.posvendas.length > 0"
  >
    <div>
      <button class="btn" style="box-shadow: none;" @click="visible = !visible">
        <i class="fab fa-buffer"></i>
        {{ this.$t('reports.ccsi.ccsiLabel') }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none;"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="wrapper-ccsi card" v-if="loader">
      <div>
        <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <!-- VENDAS -->
        <div v-if="itemsVendas.length > 0">
          VENDAS
          <div style="display: flex;">
            <div class="ccsi-chart col-3">
              <radial-progress-bar
                v-if="vendasScore !== null && vendasScore !== undefined"
                :diameter="240"
                :stroke-width="20"
                innerStrokeColor="#f1f1f1"
                :startColor="colorBalanceS"
                :stopColor="colorBalanceS"
                :completed-steps="vendasScore ? parseInt(vendasScore) : 0"
                :total-steps="1000"
              >
                <b
                  id="ccsi-vendas"
                  v-b-modal.drilldownReport
                  :style="{
                    color: colorBalanceS,
                    fontSize: '2.8em',
                    fontWeight: 'bold',
                  }"
                  >{{ vendasScore }}
                  <drilldownReport
                    :answers="respostas"
                    :questions="ccsiData.vendas"
                    title="CCSI Vendas"
                  />
                </b>
                <b-tooltip
                  v-if="vendasScore !== null && vendasScore !== undefined"
                  target="ccsi-vendas"
                  placement="bottom"
                >
                  Vendas
                  <strong>{{ vendasScore }}</strong>
                </b-tooltip>
              </radial-progress-bar>
              <div v-else>
                Sem dados para exibir
              </div>
            </div>
            <b-table
              :items="itemsVendas"
              caption-bottom
              :fields="fields"
              sort-icon-left
            >
              <template v-slot:cell(progress)="row">
                <div class="mt-2">
                  <b-progress :value="row.item.progress" :max="1000">
                  </b-progress>
                </div>
              </template>
              <template v-slot:cell(score)="row">
                <div class="text-right">
                  {{ row.item.score !=0 ? row.item.score : '-' }}
                </div>
              </template>
              <template v-slot:cell(total)="row">
                <div class="text-center">
                  {{ row.item.total }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <!-- POSVENDAS -->
        <div v-if="itemsPosvendas.length > 0">
          PÓS-VENDAS
          <div style="display: flex;">
            <div class="ccsi-chart col-3">
              <radial-progress-bar
                v-if="posvendasScore !== null && posvendasScore !== undefined"
                :diameter="240"
                :stroke-width="20"
                innerStrokeColor="#f1f1f1"
                :startColor="colorBalanceAS"
                :stopColor="colorBalanceAS"
                :completed-steps="posvendasScore ? parseInt(posvendasScore) : 0"
                :total-steps="1000"
              >
                <b
                  id="ccsi-posvendas"
                  v-b-modal.drilldownReport
                  :style="{
                    color: colorBalanceAS,
                    fontSize: '2.8em',
                    fontWeight: 'bold',
                  }"
                  >{{ posvendasScore }}
                  <drilldownReport
                    :answers="respostas"
                    :questions="ccsiData.posvendas"
                    title="CCSI Pós-Vendas"
                  />
                </b>
                <b-tooltip
                  v-if="posvendasScore !== null && posvendasScore !== undefined"
                  target="ccsi-posvendas"
                  placement="bottom"
                >
                  Pós-Vendas
                  <strong>{{ posvendasScore }}</strong>
                </b-tooltip>
              </radial-progress-bar>
              <div v-else>
                Sem dados para exibir
              </div>
            </div>
            <b-table
              :items="itemsPosvendas"
              caption-bottom
              :fields="fields"
              sort-icon-left
            >
              <template v-slot:cell(progress)="row">
                <div class="mt-2">
                  <b-progress :value="row.item.progress" :max="1000">
                  </b-progress>
                </div>
              </template>
              <template v-slot:cell(score)="row">
                <div class="text-right">
                  {{ row.item.score }}
                </div>
              </template>
              <template v-slot:cell(total)="row">
                <div class="text-center">
                  {{ row.item.total }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import api from '@/services/api';
import drilldownReport from '@/components/molecules/highcharts/reports/rankings/components/modal-drilldown';

export default {
  name: 'CssiReport',
  components: {
    RadialProgressBar,
    animatedNumber,
    drilldownReport,
  },
  props: ['showCollapsed'],
  data: () => ({
    filter: null,
    userAuth: null,
    visible: true,
    page: 1,
    limit: 10,
    ccsiData: {
      vendas: [],
      posvendas: [],
    },
    loader: false,
    itemsVendas: [],
    itemsPosvendas: [],
    vendasScore: null,
    posvendasScore: null,
    vendasQtd: 0,
    posvendasQtd: 0,
    fields: [],
    respostas: [],
    colorBalanceS: '#fff',
    colorBalanceAS: '#fff',
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountCCSI();
    },
    myActionId: function watchMyActionId() {
      this.mountCCSI();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountCCSI();
    },
    myIh1: function watchMyIh1() {
      this.mountCCSI();
    },
    myHierarchies1: function watchMyHierarchies1(){
      this.mountCCSI();
    },
    myIh2: function watchMyIh2() {
      this.mountCCSI();
    },
    myHierarchies2: function watchMyHierarchies2(){
      this.mountCCSI();
    },
    calendarDates: function watchDates() {
      this.mountCCSI();
    },
    myMetric: function watchMyMetric() {
      this.mountCCSI();
    },
    'indicatorData.value': function watchMyMetric() {
      this.mountCCSI();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountCCSI();
    },
  },
  computed: {
    ...mapState('actions', ['myActionId', 'myActionsIds', 'actionGroupData', 'allActions']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'ih1', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    async mountCCSI() {
      this.loader = true;
      const response = await api.get(`reports/ccsi`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });
      this.ccsiData = response.data;
      this.respostas = this.ccsiData.respostas;
      // builds info for VENDAS
      this.itemsVendas = [];
      this.vendasScore = null;
      this.vendasQtd = 0;
      this.ccsiData.vendas.map((obj) => {
        this.itemsVendas.push({
          question: obj.question,
          progress: (obj.average * 100).toFixed(0),
          score: (obj.average * 100).toFixed(0),
          total: obj.total,
        });
        if (obj.total > 0) {
          this.vendasQtd += 1;
        }
        if (this.vendasScore) {
          this.vendasScore += obj.average;
        } else {
          this.vendasScore = obj.average;
        }
      });
      if (this.vendasScore) {
        if (this.vendasQtd > 0) {
          this.vendasScore = (
            (100 * this.vendasScore) /
            this.vendasQtd
          ).toFixed(0);
        } else {
          this.vendasScore = 0;
        }
        this.setColorS(this.vendasScore);
      }
      // builds info for POSVENDAS
      this.itemsPosvendas = [];
      this.posvendasScore = null;
      this.posvendasQtd = 0;
      this.ccsiData.posvendas.map((obj) => {
        this.itemsPosvendas.push({
          question: obj.question,
          progress: (obj.average * 100).toFixed(0),
          score: (obj.average * 100).toFixed(0),
          total: obj.total,
        });
        if (obj.total > 0) {
          this.posvendasQtd += 1;
        }
        if (this.posvendasScore) {
          this.posvendasScore += obj.average;
        } else {
          this.posvendasScore = obj.average;
        }
      });
      if (this.posvendasScore) {
        if (this.posvendasQtd > 0) {
          this.posvendasScore = (
            (100 * this.posvendasScore) /
            this.posvendasQtd
          ).toFixed(0);
        } else {
          this.posvendasScore = 0;
        }
        this.setColorAS(this.posvendasScore);
      }
      this.loader = false;
    },
    setColorS(percentBalance) {
      if (percentBalance >= 920) {
        this.colorBalanceS = '#6bca6c';
      } else if (percentBalance < 920 && percentBalance >= 800) {
        this.colorBalanceS = '#fbcf3f';
      } else if (percentBalance < 800) {
        this.colorBalanceS = 'red';
      }
    },
    setColorAS(percentBalance) {
      if (percentBalance >= 910) {
        this.colorBalanceAS = '#6bca6c';
      } else if (percentBalance < 910 && percentBalance >= 800) {
        this.colorBalanceAS = '#fbcf3f';
      } else if (percentBalance < 800) {
        this.colorBalanceAS = 'red';
      }
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.ccsi.addQuestionLabel'),
        sortable: true,
        class: 'questionCcsi',
      },
      { key: 'progress', class: 'progressCcsi' },
      {
        key: 'score',
        label: this.$t('reports.ccsi.scoreLabel'),
        sortable: true,
        class: 'scoreCcsi',
      },
      {
        key: 'total',
        label: this.$t('reports.ccsi.totalLabel'),
        sortable: true,
        class: 'totalCcsi',
      },
    ];
  },
  mounted() {
    this.visible = !this.showCollapsed;
    if (this.userAuth.companyId === '610714d424278234e7bdae99') {
      this.mountCCSI();
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-ccsi .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-ccsi .btn .btn-light .collapsed {
  background-color: transparent;
}
.card {
  border: 1px solid rgba(0, 0, 0, 0.09);
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: #1dc86e;
  }
}
.ccsi-chart {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 30px);
}
</style>
<style>
.progressCcsi {
  width: 400px;
}
.scoreCcsi {
  width: 70px;
  padding-right: 0px !important;
}
.totalCcsi {
  width: 70px;
  padding-right: 0px !important;
}
.questionCcsi {
  width: calc(100% - 500px);
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/ccsi.vue